<template>
  <!-- Don't drop "q-app" class -->
  <div id="q-side">

     <q-stepper ref="stepper2" color="purple-13" vertical>
        <q-step default name="pricings" title="create your order:" subtitle="">
          <div class="sidebar_pricing_cont">
              <q-select
                color="gray-4"
                separator
                v-model="selectPricing"
                :options="pricingOpts"
                v-on:input="callPum"
                :suffix="fM(pricingOpts[selectPricing - 1]['pricing_amount'], pricingOpts[selectPricing - 1]['pricing_currency'])"
                @change="onChangePricing"
                v-if="pricingOpts.length > 1"
              />
              <q-field v-if="pricingOpts.length === 1">
                <span>
                  {{ pricingOpts[selectPricing - 1]['label'] }}
                </span>
                <span class="q-if-addon q-if-addon-visible pull-right">
                  {{ fM(pricingOpts[selectPricing - 1]['pricing_amount'], pricingOpts[selectPricing - 1]['pricing_currency']) }}
                </span>
              </q-field>

                <!-- ############################## -->
                <q-collapsible v-if="pricingOpts[selectPricing - 1]['pricing_description'] && pricingOpts[selectPricing - 1]['pricing_description'].trim().length" opened class="sidebar_pricing_description" label="Description">
                  <div>
                    <p class="snote">
                      {{pricingOpts[selectPricing - 1]['pricing_description']}}
                    </p>
                  </div>
                </q-collapsible>
                <!-- ############################## -->

            <p class="sidebar_pricing_variable" v-if="pricingOpts[selectPricing - 1]['pricing_type'] == 'variable'">
                            <hr class="umHr"/>
                           <p class="sidebar_pricing_pum" v-if="striX(pricingOpts[selectPricing - 1]['pum'])">
                                <span>Order</span> <q-input  class="umInput" v-model="pumQuantity" type="number" :min="pum_min()" :max="pum_max()" float-label="*multiplies the final price" />
                                {{ pricingOpts[selectPricing - 1]['pum'] }}
                           </p>
                           <p class="sidebar_pricing_sum" v-if="striX(pricingOpts[selectPricing - 1]['sum'])">
                                <span>Order</span> <q-input class="umInput" v-model="sumQuantity" type="number" :min="sum_min()" :max="sum_max()" float-label="*multiplies the final price" />
                                {{ pricingOpts[selectPricing - 1]['sum'] }}
                           </p>
            </p>

            <p class="sidebar_pricing_description snote" v-if="pricingOpts[selectPricing - 1]['pricing_type'] == 'variable'">
                The price of {{pricingOpts[selectPricing - 1]['pricing_amount']}} {{pricingOpts[selectPricing - 1]['pricing_currency'].toUpperCase()}} will be multiplied
                by number of selected {{ pricingOpts[selectPricing - 1]['pum'] }}(s).
            <span v-if="parseInt(pricingOpts[selectPricing - 1]['pum_min'])">{{ pricingOpts[selectPricing - 1]['pum_min'] }} {{ pricingOpts[selectPricing - 1]['pum'] }}(s) is minimum. </span>
            <span v-if="parseInt(pricingOpts[selectPricing - 1]['pum_max'])">{{ pricingOpts[selectPricing - 1]['pum_max'] }} {{ pricingOpts[selectPricing - 1]['pum'] }}(s) is maximum. </span>
            </p>
            <p class="sidebar_pricing_description snote" v-if="(pricingOpts[selectPricing - 1]['pricing_type'] == 'variable') && striX(pricingOpts[selectPricing - 1]['sum'])">
                The price of {{pricingOpts[selectPricing - 1]['pricing_amount']}} {{pricingOpts[selectPricing - 1]['pricing_currency'].toUpperCase()}} will be multiplied
                by number of selected {{ pricingOpts[selectPricing - 1]['sum'] }}(s).

            <span v-if="parseInt(pricingOpts[selectPricing - 1]['sum_min'])">{{ pricingOpts[selectPricing - 1]['sum_min'] }} {{ pricingOpts[selectPricing - 1]['sum'] }}(s) is minimum. </span>
            <span v-if="parseInt(pricingOpts[selectPricing - 1]['sum_max'])">{{ pricingOpts[selectPricing - 1]['sum_max'] }} {{ pricingOpts[selectPricing - 1]['sum'] }}(s) is maximum. </span>
            </p>
            <p class="sidebar_pricing_description snote" v-if="(pricingOpts[selectPricing - 1]['pricing_type'] == 'variable') && (parseInt(pricingOpts[selectPricing - 1]['pum_min']) || parseInt(pricingOpts[selectPricing - 1]['sum_min']))">
                Selecting at least <span v-if="parseInt(pricingOpts[selectPricing - 1]['pum_min'])">{{pricingOpts[selectPricing - 1]['pum_min']}} {{pricingOpts[selectPricing - 1]['pum']}}(s)</span> <span v-if="parseInt(pricingOpts[selectPricing - 1]['pum_min'])">or {{pricingOpts[selectPricing - 1]['sum_min']}}{{pricingOpts[selectPricing - 1]['sum']}}(s) </span> is required
            </p>

            <p class="sidebar_pricing_description snote" v-else>
                Price: {{pricingOpts[selectPricing - 1]['pricing_amount']}} {{pricingOpts[selectPricing - 1]['pricing_currency'].toUpperCase()}}
            </p>

            <p class="sidebar_pricing_description snote" v-if="pricingOpts[selectPricing - 1]['pricing_type'] == 'variable' && pricingOpts[selectPricing - 1]['pricing_days'] >= 1">
                This pricing option requires {{pricingOpts[selectPricing - 1]['pricing_days']}} days for fulfillment
            </p>

            <p v-bind:class="{'error':true, 'rerror':(submitStatus === 'ERROR')}" v-if="!$v.eitherUm">Enter at least one unit of measure!</p>
          </div>

          <q-stepper-navigation v-if="termOpts.length || extraOpts.length">
            <q-btn color="green-6" v-bind:disabled="this.$v.$invalid"  @click="$refs.stepper2.next(step=2) " style="left:180px;">Next</q-btn>
          </q-stepper-navigation>
        </q-step>

        <q-step name="terms"  icon="attach_money"  title="Choose terms and conditions:" subtitle=""  v-if="termOpts.length">


          <div class="sidebar_term_cont" v-if="termOpts.length">

            <q-select
              color="gray-4"
              separator
              v-model="selectTerm"
              :options="termOpts"
              v-if="termOpts.length > 1"
            />

            <q-field v-if="termOpts.length === 1">
              <span>
                {{ termOpts[selectTerm - 1]['label'] }}
              </span>
            </q-field>

            <p class="sidebar_pricing_description" v-if="termOpts">
                            {{termOpts[selectTerm - 1]['terms_description']}}
            </p>

            <p class="sidebar_pricing_description snote" v-if="termOpts && termOpts[selectTerm - 1]['terms_days'] && parseInt(termOpts[selectTerm - 1]['terms_days'], 10) > 0">
                            Choosing this option will prolong the delivery for {{termOpts[selectTerm - 1]['terms_days']}} days;
            </p>

          </div>

          <q-stepper-navigation>
            <q-btn color="grey-6" @click="$refs.stepper2.previous(step=1)">Back</q-btn>
            <q-btn color="green-6" @click="$refs.stepper2.next(step=3)" style="left:100px;" v-if="extraOpts.length">Next</q-btn>
          </q-stepper-navigation>
        </q-step>

        <q-step name="extras" icon="add" title="select extras:" subtitle="" v-if="extraOpts.length">


          <div class="sidebar_extra_cont">

            <ul id="extra-checkbox-group" v-if="extraOpts.length > 1">
              <li v-for="(extra, index) in extraOpts" v-bind:key="index">
                <q-checkbox v-model="checkExtra" :val="extra.value" :label="extra.label" />
                <span class="q-if-addon q-if-addon-visible pull-right extra-percent">
                  {{`+ ${extra.extras_percent} %`}}
                </span>
                <p class="sidebar_pricing_description snote" v-if="extra.extras_days && parseInt(extra.extras_days, 10) > 0">
                  Choosing this option will prolong the delivery for {{extra.extras_days}} days
                </p>
                <!-- ############################## -->
                <q-collapsible class="extra_desc sidebar_pricing_description" label="Description">
                  <div>
                    <p class="snote">
                        {{extra.extras_description}}
                    </p>
                  </div>
                </q-collapsible>
                <!-- ############################## -->
              </li>
            </ul>

            <!-- <q-select
              color="gray-4"
              separator
              v-model="selectExtra"
              :options="extraOpts"
              :suffix="'* ' + extraOpts[selectExtra - 1]['extras_percent'] + '%'"
               v-if="extraOpts.length > 1"
            /> -->

            <q-field v-if="extraOpts.length === 1">
              <span>
                <q-checkbox v-model="checkExtra" :val="extraOpts[0].value" :label="extraOpts[0].label" />
                <span class="q-if-addon q-if-addon-visible pull-right extra-percent">
                  {{`+ ${extraOpts[0].extras_percent} %`}}
                </span>
                <p class="sidebar_pricing_description snote" v-if="extraOpts[0].extras_days && parseInt(extraOpts[0].extras_days, 10) > 0">
                  Choosing this option will prolong the delivery for {{extraOpts[0].extras_days}} days
                </p>
                <!-- {{ extraOpts[selectExtra - 1]['label'] }} -->
              </span>
              <!-- <span class="q-if-addon q-if-addon-visible pull-right">
                {{`* ${extraOpts[selectExtra - 1]['extras_percent']} %`}}
              </span> -->
            </q-field>

            <!-- <p class="sidebar_pricing_description">
                            {{extraOpts[selectExtra - 1]['extras_description']}}
            </p> -->

            <!-- <p class="sidebar_pricing_description snote" v-if="extraOpts[selectExtra - 1]['extras_days']">
                            Choosing this option will prolong the delivery for {{extraOpts[selectExtra - 1]['extras_days']}} days;
            </p>
            <p class="sidebar_pricing_description snote" v-if="extraOpts[selectExtra - 1]['extras_percent']">
                            Choosing this option will increase the price by {{extraOpts[selectExtra - 1]['extras_percent']}}%;
            </p> -->

          </div>
          <q-stepper-navigation>
            <q-btn color="grey-6" @click="$refs.stepper2.previous(step=2)">Back</q-btn>
          </q-stepper-navigation>
        </q-step>
     </q-stepper>

  <p class="error rerror" v-if="this.$v.$invalid">Please fill the form correctly.</p>

<q-btn color="green-6"  v-bind:class="{'full-width':true, 'rerror':(submitStatus === 'ERROR'),'active':(step>=stepsCount?'active':'')}" size="lg" label="Full-width" @click="order" v-bind:disabled="this.$v.$invalid" :suffix="calcPrice()">Submit Order - {{ fM(calcPrice(), pricingOpts[selectPricing - 1]['pricing_currency'] ) }}</q-btn>

  </div>
</template>

<script>
// import store from './vuex/store'

import Vue from 'vue'


import { required, minLength, minValue, or } from 'vuelidate/lib/validators';


import accounting from 'accounting'


import { Cookies } from 'quasar'


import {
    QBtn,
    QStepper,
    QStep,
    QStepperNavigation,
    QField,
    QSelect,
    QInput,
    QCheckbox,
    QCollapsible
  } from 'quasar'

import 'quasar-extras/material-icons'

export default {
  // store,
  components: {
    QBtn,
    QStepper,
    QStep,
    QStepperNavigation,
    QField,
    QSelect,
    QInput,
    QCheckbox,
    QCollapsible
  },

  methods:{

    fM( $am, $sym){
      var curr = {"gbp": "£", "usd": "$", "eur": "€"}
      return accounting.formatMoney( $am, {symbol: curr[$sym],	decimal: ".",	thousand: ",", format: "%s%v"});
    },

    calcPrice(){

      var $price = parseInt(this.pricingOpts[this.selectPricing - 1]['pricing_amount']);

      if (window.Post.pricings[this.selectPricing]["pricing_type"] == "variable"){
          if (parseInt(this.pumQuantity)){ $price *= parseInt(this.pumQuantity)}
          if (parseInt(this.sumQuantity)){ $price *= parseInt(this.sumQuantity)}
      }

      if(this.extraOpts.length){
        this.checkExtra.forEach(eCheck => {
          if (parseInt(this.extraOpts[eCheck - 1]['extras_percent'])){
              $price *= (1 + (parseInt(this.extraOpts[eCheck - 1]['extras_percent']) / 100))
          }
        })
      }
      return $price
},

    order() {

          this.$v.$touch()
          if (this.$v.$invalid) {
            this.submitStatus = 'ERROR'
          } else {

          this.submitStatus = 'PENDING'
          if (Cookies.get('check0')){Cookies.remove('check0')};
          var created = new Date();
          Cookies.set('check0', btoa(JSON.stringify({"time": created, "data": this.aggregate() })), { path: "/", expires: 1});

          // console.log(JSON.stringify({"time": created, "data": this.aggregate() }));
          // console.log(btoa(JSON.stringify({"time": created, "data": this.aggregate() })));

       window.location.href = '/?jb_action=purchase_this&jobid=' + window.Post.info.id;

          // redirekcija

            // - job
            // - pricing + data
            //     - pum + amount
            //     - sum + amount
            // - term + data
            // - extra + data
            // - price
            // - days


            // setTimeout(() => {
            //   this.submitStatus = 'OK'
            // }, 500)
          }
    },

    aggregate(){
           var $data = {};
           $data["days"] = {}; // extras_days, terms_days, pricing_days
           $data["product"] = window.Post.info;
           $data["pricing"] = window.Post.pricings[this.selectPricing];

           if (window.Post.pricings[this.selectPricing]["pricing_type"] == "variable"){
              $data["pricing"]["pumQ"] = this.pumQuantity;
              $data["pricing"]["sumQ"] = this.sumQuantity;
           }

           $data["term"] = window.Post.terms[this.selectTerm];
           var $extra = [];
           this.checkExtra.filter((ex) => {$extra.push(window.Post.extras[ex])});
           $data["extra"] = $extra;

           $data["price"] = {};
           $data["price"]["pricing_amount"] = window.Post.pricings[this.selectPricing]["pricing_amount"];
           if (window.Post.pricings[this.selectPricing]["pricing_type"] == "variable"){
              if (parseInt(this.pumQuantity)){ $data["price"]["pumQ"] = this.pumQuantity; }
              if (parseInt(this.sumQuantity)){ $data["price"]["sumQ"] = this.sumQuantity; }
           }

           if(this.checkExtra.length){
             $data["price"]["x_perc"] = [];
             $data["days"]["ex_days"] = [];
              this.checkExtra.filter((ex) => {
                if (parseInt(window.Post.extras[ex]['extras_percent'])){
                  $data["price"]["x_perc"].push(parseInt(window.Post.extras[ex]['extras_percent']));
                }
                $data["days"]["ex_days"].push(window.Post.extras[ex]["extras_days"]);
              });
           }

           var curr = {"gbp": "£", "usd": "$", "eur": "€"};
           $data["price"]["curr"] = curr[window.Post.pricings[this.selectPricing]["pricing_currency"]];

           $data["price"]["price"] = this.calcPrice();

           $data["price"]["fprice"] = this.fM(this.calcPrice(), window.Post.pricings[this.selectPricing]["pricing_currency"]);


           $data["days"]["pr_days"] = window.Post.pricings[this.selectPricing]["pricing_days"];
           if(this.termOpts.length){
            $data["days"]["te_days"] = window.Post.terms[this.selectTerm]["terms_days"];
           }

           return $data;
    },

    striX(str){
      if(((typeof str != "undefined") && (typeof str.valueOf() == "string")) && (str.length > 0 && str.trim().length > 0)){
        return true;
      }
    },


    pum_min(){ return parseInt( this.prOpts()[this.selectPricing - 1]['pum_min'] ); },
    pum_max(){ return parseInt( this.prOpts()[this.selectPricing - 1]['pum_max'] ); },
    sum_min(){ return parseInt( this.prOpts()[this.selectPricing - 1]['sum_min'] ); },
    sum_max(){ return parseInt( this.prOpts()[this.selectPricing - 1]['sum_max'] ); },


    callPum(){

    },

    prOpts() {
      var pO = [];
      var ps = window.Post.pricings;
      Object.keys(ps).forEach(function(k, v){
        ps[k]['label'] = ps[k]['pricing_title'];
        ps[k]['value'] = k;
        pO.push(ps[k]);
      });
      return pO;
    },


    onChangePricing(){
      this.pumQuantity = this.prOpts()[this.selectPricing - 1]['pum_min'];
      this.sumQuantity = "";
    }

  },

  validations: {
    selectPricing: {
      required,
      minLength: minLength(1)
    },

    pumQuantityNumBounds: function(){

      if ( this.striX(this.prOpts()[this.selectPricing - 1]['pum_min']) && (parseInt(this.prOpts()[this.selectPricing - 1]['pum_min']) > 0)){
        if (parseInt(this.pumQuantity) < parseInt(this.prOpts()[this.selectPricing - 1]['pum_min'])){return false;}
      }
      if ( this.striX(this.prOpts()[this.selectPricing - 1]['pum_max']) && (parseInt(this.prOpts()[this.selectPricing - 1]['pum_max']) > 0)){
        if (parseInt(this.pumQuantity) > parseInt(this.prOpts()[this.selectPricing - 1]['pum_max'])){return false;}
      }
      return true;
    },

    sumQuantityNumBounds: function(){
      if (parseInt(this.pumQuantity) && (this.sumQuantity == "0" || this.sumQuantity == "00" || this.sumQuantity == "000")){return true;}
      if ( this.striX(this.prOpts()[this.selectPricing - 1]['sum_min']) && (parseInt(this.prOpts()[this.selectPricing - 1]['sum_min']) > 0)){
        if (parseInt(this.sumQuantity) < parseInt(this.prOpts()[this.selectPricing - 1]['sum_min'])){return false;}
      }
      if ( this.striX(this.prOpts()[this.selectPricing - 1]['sum_max']) && (parseInt(this.prOpts()[this.selectPricing - 1]['sum_max']) > 0)){
        if (parseInt(this.sumQuantity) > parseInt(this.prOpts()[this.selectPricing - 1]['sum_max'])){return false;}
      }
      return true;
    },

    eitherUm: function () {
      if ( this.prOpts()[this.selectPricing - 1]['pricing_type'] == 'variable' ){
        if (this.striX(this.prOpts()[this.selectPricing - 1]['pum']) && this.striX(this.prOpts()[this.selectPricing - 1]['sum'])){
            return required(this.pumQuantity) || required(this.sumQuantity)
        } else if (this.striX(this.prOpts()[this.selectPricing - 1]['pum'])){
            return required(this.pumQuantity)
        } else {
            return true
        }
      } else {
          return true
      }
    },
    selectTerm: {
      required,
      minLength: minLength(1)
    },
  },

  data () {
    return {

      selectPricing: "1",
      selectTerm: "1",
      step:1,
      pumQuantity: window.Post.pricings[1]['pum_min'],
      sumQuantity: "",
      submitStatus: null,
      checkExtra: [],

    }
  },

  computed: {

    // a computed getter
    pricingOpts: function () {
      // `this` points to the vm instance
      var pO = [];
      var ps = window.Post.pricings;
      Object.keys(ps).forEach(function(k, v){
        ps[k]['label'] = ps[k]['pricing_title'];
        ps[k]['value'] = k;
        pO.push(ps[k]);
      });
      return pO;
    },
    termOpts: function () {
      // `this` points to the vm instance
      var pO = [];
      var ps = window.Post.terms;
      Object.keys(ps).forEach(function(k, v){
        ps[k]['label'] = ps[k]['terms_title'];
        ps[k]['value'] = k;
        pO.push(ps[k]);
      });
      return pO;

    },
    extraOpts: function () {
      // `this` points to the vm instance
      var pO = [];
      var ps = window.Post.extras;
      Object.keys(ps).forEach(function(k, v){
        ps[k]['label'] = ps[k]['extras_title'];
        ps[k]['value'] = k;
        pO.push(ps[k]);
      });
      return pO;
    },
    stepsCount: function() {
      let count = 0,
          pr = window.Post.pricings,
          tr = window.Post.terms,
          ex = window.Post.extras;

      if(Object.keys(pr).length > 0) {
        count++;
      }
      if(Object.keys(tr).length > 0) {
        count++;
      }
      if(Object.keys(ex).length > 0) {
        count++;
      }
      return count;
    }
  }

}




</script>

<style>
.umInput {

    width: 62%;
    display: inline-block;
    padding: 4px 2px;
    margin: 0px 6px;

}

.umHr {
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    width: 66%;
    margin: 28px auto 4px auto;
}

#q-side p, #q-side div, #q-side span { font-size:0.85rem; color:555; }

.sidebar_pricing_cont {margin-bottom:18px;}

.sidebar_pricing_sum .q-if-label.ellipsis {margin-top:-2px;}
.sidebar_pricing_sum .q-input-target {line-height:8px;}

p.error {
  color:#d3a;
  margin:8px 0px;
  border: 0px;
  background: #eee;
  padding: 6px 8px;
  margin-top: 15px;
  border-radius: 3px;
  margin-bottom: 8px;
}

p.rerror {
  color:#f00;
  margin:8px 0px;
  border: 1px dotted #f00;
  background: #eee;
  padding: 6px 8px;
  margin-top: 15px;
  border-radius: 3px;
  margin-bottom: 8px;
}

p.snote {
  color: 555;
  line-height: 1.1rem;
  font-style: italic;
  color: #888;
  border: 0px;
  background: #eee;
  padding: 6px 8px;
  margin-top: 8px;
  border-radius: 3px;
  margin-bottom: 0px;
}

p.snote, p.snote span {
  font-size: .7rem!important;
}

.q-stepper i.q-if-control {
    font-size: 2rem;
    color: rgb(76, 175, 80);
    text-shadow: 0 0 1px rgba(0,0,0,0.5);
}

ul#extra-checkbox-group {
    padding: 0;
    margin: 20px 0;
}
ul#extra-checkbox-group li {
    margin-bottom: 10px;
}
ul#extra-checkbox-group li .sidebar_pricing_description{
  margin-left: 37px;
  margin-top: 5px
}
#q-side .q-stepper-last + div.q-stepper-step-content .q-stepper-step-inner {
    padding: 0 24px;
}
#q-side ul#extra-checkbox-group .q-option-label {
  margin-left: 16px
}
ul#extra-checkbox-group .extra-percent {
  margin-top: 3px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue?6ce38a25